import { SearchOutlined } from "@ant-design/icons";
import { Layout, Input } from "antd";
import { Outlet } from "react-router-dom";
import styled from "styled-components";
const { Header, Footer } = Layout;

export default function DefaultLayout() {
  return (
    <StyledLayout>
      <StyledHeader>
        <div className="demo-logo">BPA</div>
        <StyledInput placeholder="Search" prefix={<SearchOutlined />} />
      </StyledHeader>
      <StyledContent>
        <Outlet />
      </StyledContent>
      <StyledFooter>mits ©{new Date().getFullYear()}</StyledFooter>
    </StyledLayout>
  );
}

const StyledLayout = styled(Layout)`
  width: 100%;
  height: 100vh;
`;

const StyledHeader = styled(Header)`
  height: 64px;
  .demo-logo {
    color: #f5ad1d;
    font-size: 20px;
    font-weight: bold;
  }
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StyledContent = styled.div`
  min-height: calc(100vh - 140px);
  margin: 16px 16px 0 16px;
  background-color: white;
  padding: 8px 24px;
  border-radius: 8px;
  overflow-y: scroll;
`;

const StyledFooter = styled(Footer)`
  text-align: center;
  height: 40px;
`;
const StyledInput = styled(Input)`
  max-width: 500px;
  width: 100%;
`;
